// extracted by mini-css-extract-plugin
module.exports = {"title":"JRmjxJWQ","styledTitleCell":"fBpDeaUW","styledDescriptionCell":"ebavuUGK","styledRatingPill":"Rne1IV67"};